import React, { useEffect, useState } from "react";
import {
  createCrop,
  deleteCrop,
  fetchCrops,
  updateCrop,
} from "../../actions/crops";
import { nextSort, sortRows } from "../sortable";

import AdminFilterHeader from "../../components/AdminFilterHeader/AdminFilterHeader";
import { AdminTable } from "../AdminTable";
import { Button } from "reactstrap";
import CropsModal from "./CropsModal";
import PropTypes from "prop-types";
import { connect } from "react-redux";

const Crops = (props) => {
  const [openModalCrop, setOpenModalCrop] = useState(false);
  const [cropToUpdate, setCropToUpdate] = useState(null);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState({ sortKey: "name", sortDir: "asc" });

  const handleFilterChange = (event) => {
    setSearch(event.target.value);
  };

  const handleSort = (column) => setSort((prev) => nextSort(prev, column));

  const filteredCrops =
    search === ""
      ? props.crops
      : props.crops.filter((crop) => {
          return crop.name.toLowerCase().includes(search.toLowerCase());
        });
  const sortedCrops = sortRows(
    filteredCrops,
    sort.sortKey,
    sort.sortDir,
    (crop) => crop.name || ""
  );
  useEffect(() => {
    props.fetchCrops();
  }, []);

  const openCropModalForUpdate = (event, crop) => {
    event.preventDefault();
    setCropToUpdate(crop);
    setOpenModalCrop(true);
  };

  const deleteSelectedCrop = (crop) => {
    if (window.confirm(`Do you want to delete ${crop.name} ?`))
      props.deleteCrop(crop);
  };

  const columns = [
    { key: "name", label: "Name", className: "w-75", sortable: true },
    {
      key: "actions",
      label: "Actions",
      className: "w-25",
      cell: (crop) => (
        <div className="admin-actions">
          <Button
            data-tooltip-id="tooltip"
            data-tooltip-content="Edit crop information"
            color="link"
            onClick={(event) => openCropModalForUpdate(event, crop)}
          >
            <i className="fa-solid fa-lg fa-pencil" />
          </Button>
          <Button
            data-tooltip-id="tooltip"
            data-tooltip-content="Delete crop"
            data-tooltip-variant="error"
            className="admin-actions__danger"
            color="link"
            onClick={() => deleteSelectedCrop(crop)}
          >
            <i className="fa-solid fa-lg fa-trash-can" />
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div className="mt-3 ps-3">
      <CropsModal
        setCropToUpdate={setCropToUpdate}
        cropToUpdate={cropToUpdate}
        createCrop={props.createCrop}
        updateCrop={props.updateCrop}
        setOpenModalCrop={setOpenModalCrop}
        isOpen={openModalCrop}
      />

      <AdminFilterHeader
        adminOnly
        onButtonClick={() => setOpenModalCrop(true)}
        onFilterChange={handleFilterChange}
        onRefresh={props.fetchCrops}
        refreshing={props.refreshing}
        buttonName="New crop"
        search={search}
      />
      <AdminTable
        columns={columns}
        rows={sortedCrops}
        loading={props.refreshing}
        sortKey={sort.sortKey}
        sortDir={sort.sortDir}
        onSort={handleSort}
      />
    </div>
  );
};

Crops.propTypes = {
  crops: PropTypes.array.isRequired,
  refreshing: PropTypes.bool.isRequired,
  fetchCrops: PropTypes.func.isRequired,
  createCrop: PropTypes.func.isRequired,
  updateCrop: PropTypes.func.isRequired,
  deleteCrop: PropTypes.func.isRequired,
};
function mapStateToProps(state) {
  return {
    crops: state.crops.all,
    refreshing: state.crops.table.refreshing,
  };
}

const callbacks = {
  fetchCrops,
  createCrop,
  updateCrop,
  deleteCrop,
};

export default connect(mapStateToProps, callbacks)(Crops);
